import type { ReactNode } from 'react';

import { Typography } from '@remarkable/ark-web';

import { Trans } from '@lingui/react/macro';
import { Button, Modal } from 'src/components';

interface VerifyUnpairModalProps {
  onUnpair: () => void;
  title: ReactNode;
  isUnpairing: boolean;
  content?: ReactNode;
}

export const VerifyUnpairModal = ({
  onUnpair,
  title,
  isUnpairing,
  content,
}: VerifyUnpairModalProps) => (
  <Modal.Content>
    <div data-cy="verify-unpair-modal-content">
      <Typography variant="heading-md">{title}</Typography>
      {content}
      <div className="mt-32 flex w-full flex-col items-center gap-16 px-32 md:flex-row md:justify-evenly">
        <Modal.Close asChild>
          <Button
            data-cy="cancel-unpair-device-button"
            variant="secondary"
            className="w-full flex-1"
          >
            <Trans>No, cancel</Trans>
          </Button>
        </Modal.Close>

        <Button
          data-cy="confirm-unpair-device-button"
          className="w-full flex-1"
          variant="primary"
          onClick={onUnpair}
          loading={isUnpairing}
        >
          <Trans>Yes, unpair</Trans>
        </Button>
      </div>
    </div>
  </Modal.Content>
);
